import { useState } from "react";
import { ShipmentUpdateModel } from "../apiModels/shipmentUpdateModel";
import { ShipmentDetailsModalStatus } from "../appConstants";
import { formatNullableString, logError, toNullableLocaleDateTimeString } from "../utilities";
import ConfirmModal, { ButtonLoadingSpinner, ElementWithKey } from "./ConfirmModal";
import ShipmentUpdateDetailsModal from "./ShipmentUpdateDetailsModal";
import ShipmentUpdateEditModal from "./ShipmentUpdateEditModal";
import { toast } from "react-toastify";
import { deleteShipmentUpdate } from "../api/shipmentUpdateApi";

export default function ShipmentUpdateHistoryTableRowFormatter(props: {
    shipmentUpdate: ShipmentUpdateModel,
    reloadShipment: () => void,
    canEdit: boolean,
}) {
    const notifyUserOfError = (err: string) => toast(err, { type: 'error' });
    const notifyUserOfSuccess = (msg: string) => toast(msg, { type: 'success' });

    const shipmentUpdate = props.shipmentUpdate;

    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState<boolean>(false);
    const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);
    const [deleteConfirmProcessing, setDeleteConfirmProcessing] = useState<boolean>(false);

    const deleteHistoryRecord = async () => {
        setDeleteConfirmProcessing(true);
    
        try {
            const s = await deleteShipmentUpdate(shipmentUpdate.shipmentUpdateId);

            setDeleteConfirmProcessing(false);
            notifyUserOfSuccess('Update deleted successfully.');
            props.reloadShipment();
            setShowConfirmDeleteModal(false);
        }
        catch (error: any) {
            if (error instanceof Error) {
                notifyUserOfError(error.message);
            }

            logError(error);
            setDeleteConfirmProcessing(false);
        }
    };

    const ApproveConfirmModalButtons: ElementWithKey[] = [
        {
            key: 0,
            element: <button
                className='btn btn-primary'
                onClick={() => deleteHistoryRecord()}
                disabled={deleteConfirmProcessing}>
                {deleteConfirmProcessing ? <ButtonLoadingSpinner /> : 'Approve'}
            </button>
        },
        {
            key: 1,
            element: <button
                className='btn btn-default'
                onClick={() => setShowConfirmDeleteModal(false)}>
                Cancel
            </button>
        }
    ];

    return (
        <>
            <tr key={shipmentUpdate.shipmentStatusId}>
                <td>
                    <button className="btn btn-sm btn-outline-primary me-1" onClick={() => {
                        setShowDetailsModal(true);
                    }}>
                        <i className="bi bi-search"></i>
                    </button>
                    {props.canEdit &&
                    <button className="btn btn-sm btn-outline-primary me-1" onClick={() => {
                        setShowEditModal(true);
                    }}>
                        <i className="bi bi-pencil"></i>
                    </button>}
                    {props.canEdit &&
                    <button className="btn btn-sm btn-outline-danger me-1" onClick={() => setShowConfirmDeleteModal(true)}>
                        <i className="bi bi-trash"></i>
                    </button>}
                </td>
                <td>{formatNullableString(shipmentUpdate.shipmentTrackingNumber)}</td>
                <td>{formatNullableString(shipmentUpdate.description)}</td>
                <td>{formatNullableString(shipmentUpdate.location)}</td>
                <td>{formatNullableString(shipmentUpdate.shipmentStatus)}</td>
                <td>{toNullableLocaleDateTimeString(shipmentUpdate.updateTime)}</td>
            </tr>
            <ConfirmModal title='Confirm Delete'
                body='Are you sure you want to delete this tracking update?'
                buttons={ApproveConfirmModalButtons}
                show={showConfirmDeleteModal}
                setShow={setShowConfirmDeleteModal} />
            <ShipmentUpdateDetailsModal show={showDetailsModal}
                setShow={setShowDetailsModal}
                shipmentUpdate={shipmentUpdate} />
            <ShipmentUpdateEditModal show={showEditModal}
                setShow={setShowEditModal}
                shipmentUpdate={shipmentUpdate}
                postSaveActions={props.reloadShipment} />
        </>
    );
};